/** 카테고리별 결과 테이블 (관세율표 / 분류사례 / 주·해설 / 관련법령 공용). */
import React from "react";
import "./theme.css";

export default function ResultSection({
  title,
  count,
  columns,
  rows = [],
  loading = false,
  highlighted = new Set(),
  onRowClick,
  emptyMessage = "결과 없음",
}) {
  return (
    <section
      className="audit-root"
      style={{
        marginBottom: 16,
        border: "1px solid var(--audit-border)",
        borderRadius: 6,
        background: "var(--audit-bg-elevated)",
        overflow: "hidden",
      }}
    >
      <header
        style={{
          padding: "10px 14px",
          borderBottom: "1px solid var(--audit-border)",
          background: "var(--audit-bg-subtle)",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <span
          style={{ fontSize: 14, lineHeight: "21px", fontWeight: 600, color: "var(--audit-text)" }}
        >
          {title}
        </span>
        <span
          style={{
            fontSize: "var(--audit-type-caption-size)",
            color: "var(--audit-text-muted)",
            fontFamily: "JetBrains Mono, monospace",
          }}
        >
          ({count ?? rows.length})
        </span>
        {loading && (
          <span
            style={{
              marginLeft: "auto",
              fontSize: "var(--audit-type-caption-size)",
              color: "var(--audit-text-muted)",
            }}
          >
            로딩...
          </span>
        )}
      </header>

      {rows.length === 0 && !loading ? (
        <div
          style={{
            padding: 16,
            fontSize: "var(--audit-type-body-small-size)",
            lineHeight: "var(--audit-type-body-small-line)",
            color: "var(--audit-text-muted)",
            fontStyle: "italic",
          }}
        >
          {emptyMessage}
        </div>
      ) : (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "var(--audit-type-table-size)",
            lineHeight: "var(--audit-type-table-line)",
          }}
        >
          <thead>
            <tr style={{ background: "var(--audit-bg-subtle)" }}>
              {columns.map((col) => (
                <th
                  key={col.key}
                  style={{
                    padding: "5px 10px",
                    textAlign: "left",
                    color: "var(--audit-text-muted)",
                    fontWeight: 500,
                    fontSize: "var(--audit-type-label-size)",
                    borderBottom: "1px solid var(--audit-border)",
                    width: col.width,
                  }}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => {
              const isStarred = highlighted.has(
                row.case_id || row.hsk || row.location,
              );
              return (
                <tr
                  key={row.id || row.case_id || row.hsk || row.location || idx}
                  onClick={() => onRowClick?.(row)}
                  style={{
                    cursor: onRowClick ? "pointer" : "default",
                    borderBottom: "1px solid var(--audit-border)",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "var(--audit-bg-hover)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  {columns.map((col, colIdx) => (
                    <td
                      key={col.key}
                      style={{
                        padding: "5px 10px",
                        color: "var(--audit-text)",
                        fontFamily: col.mono
                          ? "JetBrains Mono, monospace"
                          : "inherit",
                        position: "relative",
                      }}
                    >
                      {colIdx === 0 && isStarred && (
                        <span
                          style={{
                            color: "var(--audit-accent)",
                            marginRight: 4,
                            fontSize: "var(--audit-type-caption-size)",
                          }}
                          title="AI 추천 선례"
                        >
                          ★
                        </span>
                      )}
                      {col.render ? col.render(row) : row[col.key]}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </section>
  );
}
